/**
 * 题目笔记管理服务
 * 管理用户对题目的笔记，使用 localStorage 持久化
 */

const NOTES_KEY = 'examflow_question_notes';

interface NoteEntry {
  questionId: string;
  note: string;
  updatedAt: number;
}

/**
 * 获取指定题目的笔记
 */
export function getNote(questionId: string): string | null {
  const notes = getAllNotes();
  const entry = notes.find((n) => n.questionId === questionId);
  return entry ? entry.note : null;
}

/**
 * 设置题目的笔记
 */
export function setNote(questionId: string, note: string): void {
  const notes = getAllNotesRaw();
  const existingIndex = notes.findIndex((n) => n.questionId === questionId);

  if (existingIndex >= 0) {
    notes[existingIndex] = { questionId, note, updatedAt: Date.now() };
  } else {
    notes.push({ questionId, note, updatedAt: Date.now() });
  }

  localStorage.setItem(NOTES_KEY, JSON.stringify(notes));
}

/**
 * 删除题目的笔记
 */
export function deleteNote(questionId: string): void {
  const notes = getAllNotesRaw().filter((n) => n.questionId !== questionId);
  localStorage.setItem(NOTES_KEY, JSON.stringify(notes));
}

/**
 * 获取所有笔记（仅返回 questionId 和 note）
 */
export function getAllNotes(): { questionId: string; note: string }[] {
  return getAllNotesRaw().map((n) => ({
    questionId: n.questionId,
    note: n.note,
  }));
}

/**
 * 获取所有笔记（原始数据，包含 updatedAt）
 */
function getAllNotesRaw(): NoteEntry[] {
  try {
    const raw = localStorage.getItem(NOTES_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter(
      (item): item is NoteEntry =>
        typeof item === 'object' &&
        typeof item.questionId === 'string' &&
        typeof item.note === 'string'
    );
  } catch {
    return [];
  }
}
